import { renderPlural } from "@repo/ui/helpers/helpers";
import { NumberFormatter } from "@repo/ui/numbers/numberFormatter";
import type { FC } from "react";

export interface FilterResultSummaryProps {
  count: number;
  denominatorCount?: number;
}

/** "12 of 340 items" (or just "12 items" without a denominator) for the filter bar's result slot. */
export const FilterResultSummary: FC<FilterResultSummaryProps> = ({
  count,
  denominatorCount,
}) => {
  if (denominatorCount !== undefined) {
    return renderPlural(denominatorCount, {
      one: (
        <>
          <NumberFormatter value={count} /> of 1 item
        </>
      ),
      other: () => (
        <>
          <NumberFormatter value={count} /> of{" "}
          <NumberFormatter value={denominatorCount} /> items
        </>
      ),
    });
  }

  return renderPlural(count, {
    one: "1 item",
    other: () => (
      <>
        <NumberFormatter value={count} /> items
      </>
    ),
  });
};
